import { configureStore } from "@reduxjs/toolkit";
import adminMenuReducer   from "../slice/admin/adminMenuSlice";
import userReducer        from "../slice/user/userSlice";
import authReducer        from "../slice/auth/authSlice";
import categoryReducer    from "../slice/category/categorySlice";
import subCategoryReducer from "../slice/subCategory/subCategorySlice";
import productReducer     from "../slice/product/productSlice";
import cartReducer        from "../slice/cart/cartSlice";
import adminUserReducer   from "../slice/adminUser/adminUser";
import checkoutReducer    from "../slice/checkout/checkoutSlice";
import orderReducer       from "../slice/order/orderSlice";
import dashboardReducer   from "../slice/dashboard/Dashboardslice";
import searchReducer      from "../slice/search/searchSlice";
import bannerReducer      from "../slice/banner/bannerSlice";
import permissionReducer  from "../slice/permission/permissionSlice";
import addressReducer     from "../slice/address/addressSlice";
import taxmasterReducer   from "../slice/taxMaster/taxMasterSlice";
import stockEntryReducer  from "../slice/stockentry/Stockentryslice";
import offerReducer       from "../slice/offer/offerslice";
import customerReducer       from "../slice/customer/customerslice";
import notificationReducer       from "../slice/Notification/notificationSlice";
import ratingReducer       from "../slice/rating/ratingSlice";
import galleryImageReducer from "../slice/gallery/galleryImageSlice";
import millingSlotReducer  from "../slice/milling/millingSlotSlice";
export const store = configureStore({
  reducer: {
    adminMenu:   adminMenuReducer,
    user:        userReducer,
    auth:        authReducer,
    category:    categoryReducer,
    subCategory: subCategoryReducer,
    product:     productReducer,
    cart:        cartReducer,
    adminUser:   adminUserReducer,
    checkout:    checkoutReducer,
    orders:      orderReducer,
    dashboard:   dashboardReducer,
    search:      searchReducer,
    banner:      bannerReducer,
    permission:  permissionReducer,
    address:     addressReducer,
    taxMaster:   taxmasterReducer,
    stockEntry:  stockEntryReducer,
    offer:       offerReducer,
    customer:    customerReducer,
    notification:    notificationReducer,
    rating: ratingReducer,
    galleryImage: galleryImageReducer,
    millingSlot:  millingSlotReducer,
  },
});